var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C3.589 2 0 5.589 0 10C0 11.7405 0.557 13.4005 1.611 14.801L1.7605 15H14.239L14.389 14.801C15.443 13.4005 16 11.7405 16 10C16 5.589 12.411 2 8 2ZM8.5 3.5V5H7.5V3.5H8.5ZM1.5 10.5H3V9.5H1.5V10.5ZM4.11096 6.81797L3.05046 5.75747L3.75746 5.04997L4.81796 6.11047L4.11096 6.81797ZM7.1455 10.411C7.373 10.9145 7.965 11.138 8.4685 10.911C8.972 10.684 9.196 10.0915 8.9685 9.58846C8.7415 9.08496 6 5.44246 6 5.44246C6 5.44246 6.9185 9.90796 7.1455 10.411ZM11.8891 6.81797L11.1821 6.11097L12.2426 5.04997L12.9496 5.75697L11.8891 6.81797ZM14.5 9.5H13V10.5H14.5V9.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.2758da56.svg";
export { ForwardRef as ReactComponent };